/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Flex, List, Modal } from 'antd';
import { useLanguage } from 'hooks/Language/useLanguage';
import CountdownTimer from '../CountdownTimer';

export interface PartnerResponseModalProps {
  open: boolean;
  onClose: () => void;
  data: PartnerResponseType;
  handleBackClick: () => void;
}

export interface VoucherType {
  TransferNumber: string;
  SecurityCode: string;
}

export interface ValuesType {
  text: string;
  value: string | number;
}

export interface PartnerResponseType {
  Voucher: VoucherType;
  Description: string;
  TotalAmount: string;
  values: ValuesType[];
  SplitTransactionNumber: any;
  ValidityInMinutes: any;
  TransactionQRCode: string;
}

const PartnerResponseModal: React.FC<PartnerResponseModalProps> = ({
  open,
  onClose,
  data,
  handleBackClick,
}) => {
  const { translate } = useLanguage();
  const valuesData = Array.isArray(data?.values)
    ? data.values.map((item: ValuesType) => ({
        title: item.text,
        value: item.value,
      }))
    : [];

  const transferNumber = data?.Voucher?.TransferNumber
    ? {
        title: translate('Transfer Number'),
        value: data?.Voucher?.TransferNumber || '',
      }
    : null;

  const securityCode = data?.Voucher?.SecurityCode
    ? {
        title: translate('Security Code'),
        value: data?.Voucher?.SecurityCode || '',
      }
    : null;

  const splitTransactionNumber: any = data?.SplitTransactionNumber
    ? {
        title: translate('Transaction number'),
        value: data?.SplitTransactionNumber || '',
      }
    : null;

  const listData: any = [
    {
      title: translate('Total Amount'),
      value: data?.TotalAmount || '',
    },

    transferNumber,
    securityCode,
    ...valuesData,
    splitTransactionNumber,
  ].filter(Boolean);

  // const qrCodeUrl = data?.TransactionQRCode;

  return (
    <Modal
      title={
        <span className="medium-text">{data?.Description || ''}</span>
      }
      open={false}
      // open={open}
      onCancel={() => {
        onClose();
        handleBackClick();
      }}
      footer={
        <Flex>
          <Button onClick={onClose} danger ghost type="primary">
            {translate('Close')}
          </Button>
        </Flex>
      }
    >
      {/* {data?.TransactionQRCode && <img src={qrCodeUrl} />} */}
      <List
        dataSource={listData}
        style={{ width: '100%' }}
        renderItem={(
          item: { title: string; value: string },
          index: number,
        ) => (
          <List.Item key={index}>
            <Flex justify="space-between" style={{ width: '100%' }}>
              <span className="medium-text">{item.title}</span>
              <span className="medium-text">{item.value}</span>
            </Flex>
          </List.Item>
        )}
      />
      {data?.ValidityInMinutes && (
        <CountdownTimer
          duration={parseInt(data?.ValidityInMinutes)}
        />
      )}
    </Modal>
  );
};

export default PartnerResponseModal;
